import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useQuery,
} from '@tanstack/react-query';

import { HttpClientError } from '../clients/http/HttpClient';
import { dataEntitlementService } from '../services/DataEntitlementService';

export type DataEntitlements = {
  hasIntelligenceAccess: boolean;
};

interface DataEntitlementsReturnType {
  dataEntitlements: DataEntitlements;
  loading: boolean;
  refetchEntitlements: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => Promise<QueryObserverResult<DataEntitlements, HttpClientError>>;
}

export const DATA_ENTITLEMENTS_CACHE_KEY = 'data_entitlements';

export const useDataEntitlements = (): DataEntitlementsReturnType => {
  const {
    data: entitlements,
    isLoading,
    refetch,
  } = useQuery<DataEntitlements, HttpClientError>({
    queryFn: dataEntitlementService.get,
    queryKey: [DATA_ENTITLEMENTS_CACHE_KEY],
    staleTime: 2000,
  });

  return {
    dataEntitlements: entitlements || { hasIntelligenceAccess: false },
    loading: isLoading,
    refetchEntitlements: refetch,
  };
};
